import Vue from 'vue'

import auth from './modules/auth.js'
import user from './modules/user'
import studies from './modules/studies'
import appData from './modules/appData.js'
import system from './modules/system.js'
import interests from './modules/interests.js'
import dashboard from './modules/dashboard.js'
import forum from './modules/forum'
import search from './modules/search'
import notifications from './modules/notifications'
import popupStates from './modules/popupStates'
import push from './modules/push'
import sessions from './modules/sessions'

let Api = {
  auth,
  user,
  appData,
  studies,
  system,
  interests,
  dashboard,
  search,
  notifications,
  popupStates,
  push,
  sessions,
  forum: forum()
}

export default Api

Vue.prototype.$api = Api
